<template>
    <div style="width: 100%;height: 100%;">
        <!-- viewBox="5 20 30 310"  width="100" height="210px" -->
      <svg viewBox="5 20 30 310">
        <polyline
          class="shap"
          points="20,100,20,0"
          stroke-dasharray="2 3"
          style="fill:none;stroke:rgb(151, 151, 151);stroke-width:4"
          :style="{'stroke':borderColor}"
        />
        
      </svg>
      <!-- <div class="shap"></div> -->
    </div>
  </template>

<script>
export default {
  inject:['getNode'],
  data() {
    return {
      borderColor: 'rgb(151, 151, 151)',
    };
  },
  mounted(){
    const node = this.getNode();
    node.on('change:data',(res)=>{
      console.log("数据发生改变",res)
      this.borderColor = res.current.borderColor;
    })
  }
};
</script>

<style scoped>
.shap {
    /* height: 100%;
    border:5px dashed transparent;
    border-left: 5px dashed black; */
    animation: shine 0.6s infinite linear;
}
/* @keyframes shine {
  0% {
    transition: translate(100%);
  }
  100% {
    transition: translate(200%);
  }
} */
/* dasharray 加起来15+4 = 19 */
@keyframes shine {
  0% {
    stroke-dashoffset: 19px;  
  }
  100% {
    stroke-dashoffset: 0px;
  }
}
</style>